import React, { Component } from 'react'
import Card from '../Card'
import injectSheet from 'react-jss'
import { injectStripe, CardElement } from 'react-stripe-elements'
import { palette, formStyle } from '../../../Theme/Theme'
import { apiUrl } from '../../../Utility'
// import ReactGA from 'react-ga'
import Responsive from 'react-responsive'
import Color from 'color'
import {HotKeys} from 'react-hotkeys';
import TagManager from 'react-gtm-module'


const Desktop = props => <Responsive {...props} minWidth={1025} />
const Tablet = props => <Responsive {...props} minWidth={736} maxWidth={1024}/>
const Mobile = props => <Responsive {...props} maxWidth={735} />

class CardInfoForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      buttonContent: 'Submit',
      code: '',
      message: '',
      couponIsNotEmpty: false,
      couponIsValid: false
    }
  }

  render() {
    const { CardFormHeader, body, CreditCard, Coupon, CardSubmit, CardFormFooter, StripeLogo, CouponInput, ApplyButton } = this.props.classes


    const map = {
      next: 'enter'
    };

    const handlers = {
      next: this.onSubmit
    }
    return <Card style={{padding: '0rem 2rem', justifyContent: 'space-around'}}>
    <HotKeys keyMap={map} handlers={handlers}>
      <Desktop>
        <div className={CardFormHeader} style={{margin: '0rem'}}>
          <h1>Payment Method</h1>
        </div>
      </Desktop>
      <Tablet>
        <div className={CardFormHeader} style={{margin: '0rem'}}>
          <h1>Payment Method</h1>
        </div>
      </Tablet>
      <Mobile>
        <div className={CardFormHeader} style={{margin: '0rem'}}>
          <h1 style={{fontSize: '1.5rem'}}>Payment Method</h1>
        </div>
      </Mobile>
      <p style={{textAlign: 'center', paddingBottom: '1rem', color: this.state.couponIsValid ? palette.blue : palette.orange}}>{this.state.message}</p>
      <div className={body}>
        <div className={CreditCard}>
          <CardElement style={CardFormStyle}/>
        </div>
        <div className={Coupon} style={{marginTop: '1rem'}}>
          <span className={CouponInput}>
            <i className="fas fa-gift" data-fa-transform="right-1"></i>
            <input style={{background: 'transparent', color: '#FAFAFA'}} type="text" placeholder='Coupon Code' value={this.state.code} onChange={this.onChange}/>
          </span>
          <span className={ApplyButton}>
            {this.state.couponIsNotEmpty ? <span onClick={this.applyCoupon}>apply</span> : null}
          </span>
        </div>
        <button onClick={this.onSubmit} className={CardSubmit}>{this.state.buttonContent}</button>
      </div>
      <div className={CardFormFooter}>
        Powered by <a href="https://www.stripe.com" target="_blank" rel="noopener noreferrer"><i className={`fab fa-stripe fa-2x ${StripeLogo}`}/></a>
      </div>
      </HotKeys>
    </Card>
  }

  componentDidMount () {
    // ReactGA.pageview('/welcome/signup/paymentMethod');
    TagManager.dataLayer({
      dataLayer: {
          event: 'PageView',
          page: '/welcome/signup/paymentMethod',
      }
    })
  }   

  onChange = e => {
    const { value } = e.target
    const newState = { code: value }

    // Show or hide 'apply'
    if (value !== '') {
      newState.couponIsNotEmpty = true
    } else {
      newState.couponIsNotEmpty = false
    }

    // Set the state
    this.setState(newState)
  }

  applyCoupon = () => {
    const { plan } = this.props
    const { code } = this.state

    let validCoupon = false

    const req = new Request(`https://${apiUrl}/api/v1/coupon_check`, {
      method: 'POST',
      body: JSON.stringify({ couponCode: code }),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })

    // Check coupon
    fetch(req)
      .then(response => {
          response.json().then(data => {
            console.log(data)
            if (data.status === 'failure') {
              this.setState({ couponIsValid: false, message: data.message })
            } else {
              validCoupon = true
              console.log(data)
              if (plan.includes('month') && !data.couponDetails.appliesMonthly) {
                this.setState({ couponIsValid: false, message: 'That coupon is only for annual plans' })
                validCoupon = false
                return
              }
              if (plan.includes('annual') && !data.couponDetails.appliesAnnual) {
                this.setState({ couponIsValid: false, message: 'That coupon is only for monthly plans' })
                validCoupon = false
                return
              }
              this.setState({ couponIsValid: true, message: data.couponDetails.description })
            }
          })
      })
  }

  onSubmit = e => {
    // const { dispatch, plan, history } = this.props
    const { code, couponIsValid, couponIsNotEmpty } = this.state
    e.preventDefault()

    if (couponIsNotEmpty && !couponIsValid) {
      return
    }

    const newButtonContent = <i className="fas fa-spinner fa-spin"></i>
    this.setState({
      buttonContent: newButtonContent
    })
    if (this.props.stripe) {
      this.props.stripe
        .createToken()
        .then(data => {
          this.props.onSubmit(data.token.id, code)
        })
    } else {
      console.log("Stripe.js hasn't loaded yet.")
    }
  }
}

const CardFormStyle = {
  base: {
    color: '#FAFAFA',
    fontSize: '16px'
  }
}

const styles = {
  ...formStyle,
  CardFormHeader: {
    color: palette.white,
    textAlign: 'center',
    padding: '2rem 1rem'
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center'
  },
  CardFormBody: {
    flex: '2',
    margin: '0rem .5rem',
    width: '25rem',
    color: '#FAFAFA',
    maxWidth: '100%',
    background: 'transparent',
    border: 'none',
    borderBottom: `1px solid ${palette.white}`,
    // boxShadow: '1px 1px 1px 1px rgb(220, 220, 220)',
    padding: '.5rem 1rem'
  },
  CreditCard: {
    composes: '$CardFormBody'
  },
  Coupon: {
    composes: '$CardFormBody',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  CardSubmit: {
    background: palette.blue,
    marginTop: '1rem',
    height: '2.5rem',
    width: '8rem',
    border: 'none',
    borderRadius: '5px',
    boxShadow: `1px 1px 3px 1px ${Color(palette.black).darken(0.5)}`,
    color: 'rgb(250, 250, 250)',
    fontSize: '16px',
    transition: '.5s',
    '&:hover': {
      background: palette.purple,
      cursor: 'pointer'
    },
    '&:focus': {
      outline: 'none'
    },
    '&:active': {
      background: 'red'
    }
  },
  CardFormFooter: {
    display: 'flex',
    flexDirection: 'row',
    padding: '1rem 0rem',
    justifyContent: 'center',
    alignItems: 'center',
    height: '4rem',
    color: 'rgb(150, 150, 150)'
  },
  StripeLogo: {
    color: palette.blue,
    marginLeft: '.2rem'
  },
  CouponInput: {
    '& i': {
      marginRight: '1rem',
      color: 'rgb(200, 200, 200)'
    },
    '& input': {
      color: 'rgb(20, 20, 20)',
      fontFamily: 'Helvetica, Arial',
      border: 'none',
      fontSize: '1rem',
      '&:focus': {
        outline: 'none'
      }
    }
  },
  ApplyButton: {
    color: 'rgb(80, 80, 80)',
    transition: 'color .5s',
    '&:hover': {
      color: palette.blue,
      cursor: 'pointer'
    }
  }
}

export default injectStripe(injectSheet(styles)(CardInfoForm))


// WEBPACK FOOTER //
// ./src/js/Components/LandingPage/SignupComponents/CardInfoForm.jsx